import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { getAgendaControlType, getAgendaList, getAgendaSurveys, getAttendeesSurveys, PostAddAgenda, PutUpdateAgenda } from "./AgendaRepo"
import { toast } from "react-toastify"
import { showToast } from "../../../utils/toastUtils"

interface AgendaListInteface {
  page?:number,
  limit?:number,
  search?:string
}

export const useGetAgendaList =({enabled=false,params}:{enabled:boolean,params:AgendaListInteface})=>{
 return useQuery({
    queryKey:['GET_AGENDA_LIST',params],
    queryFn:()=>getAgendaList(params),
    enabled:enabled,
    retry:false
 })
}

export const useGetAgendaControlType = ({enabled=false})=>{
  
    return useQuery({
        queryKey:['GET_AGENDA_CONTROL_TYPE'],   
        queryFn:getAgendaControlType,
        retry:false,
        enabled:enabled
    })
}
interface ReBodyInterface{

  Agendname: string,
  Agendacontroltype: string,
  Orgunitid: number,
  Status:string,
  IsPrivate:boolean,
  Agendaimage: number,
  SurveryIdForQuestions?: number | null,
  HasAttendees?: boolean | null,
  SurveryIdForAttendeesQuestions?: number | null
}

export const useAddAgenda =()=>{
  const queryClient = useQueryClient();
  return useMutation({
   mutationFn:(ReqBoady:ReBodyInterface)=>PostAddAgenda(ReqBoady),
   onSuccess:()=>{
    showToast.success('Agenda Added Successfully')
     queryClient.invalidateQueries({queryKey:['GET_AGENDA_LIST']})
   },
   onError:(error:any)=>{
    console.log('Failed to Add AGenda',error.message);
    showToast.error('Faield to Add Agenda');
   }
  })
}

interface UpdateReqBodyInterface{
  Agendatypeid:number 
  Agendname: string,
  Agendacontroltype:string ,
  Orgunitid:number ,
  Status: string,
  IsPrivate: boolean,
  Agendaimage: number,
  SurveryIdForQuestions?: number | null,
  HasAttendees?: boolean | null,
  SurveryIdForAttendeesQuestions?: number | null
}



export const useUpdateAgenda=()=>{
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn:(ReqBoady:UpdateReqBodyInterface)=>PutUpdateAgenda(ReqBoady),
     onSuccess:()=>{
     showToast.success('Updated Successfully')
      queryClient.invalidateQueries({queryKey:['GET_AGENDA_LIST']});
     },
     onError:(error:any)=>{
      showToast.error('Failed to Update');
      console.log('Failed to Update',error.message);
     }
  })
}

export const useGetAgendaSurveys=({enable=false}:{enable:boolean})=>{
  return useQuery({
     queryKey:['GET_AGENDA_SURVEYS'],
     queryFn:getAgendaSurveys,
     retry:false,
     enabled:enable
  })
}

export const useGetAttendeesSurveys=({enable=false}:{enable:boolean})=>{
  return useQuery({
     queryKey:['GET_ATTENDEES_SURVEYS'],
     queryFn:getAttendeesSurveys,
     retry:false,
     enabled:enable
  })
}